/* eslint-disable */
import '@/js/desktop/plugins/sliderPro/jquery.sliderPro.min';
import './gallery.css';

var initGallery = function () {
	var $slider = $(".js-hotel-page-slider"),
		widowSizeSlideRender = null,
		baseSliderOptions = {
			width: "100%",
			arrows: true,
			buttons: false,
			waitForLayers: true,
			fade: false,
			autoplay: false,
			autoScaleLayers: false,
			imageScaleMode: "cover",
			slideDistance: 5,
			fadeArrows: false,
			fullScreen: true,
			fadeFullScreen: false
		};

	$(window).on("resize", function () {
		var width = $(this).width();
		if (width >= 1441 && widowSizeSlideRender !== 1320) {
			widowSizeSlideRender = 1320;
			$slider.sliderPro(_.extend({}, baseSliderOptions, {
				height: 356,
				thumbnailWidth: 138,
				thumbnailHeight: 116,
				thumbnailsPosition: "bottom"
			}));

		} else if (width >= 1241 && width < 1441 && widowSizeSlideRender !== 1160) {
			widowSizeSlideRender = 1160;
			$slider.sliderPro(_.extend({}, baseSliderOptions, {
				height: 372,
				thumbnailWidth: 119,
				thumbnailHeight: 99,
				thumbnailsPosition: "bottom"
			}));
		} else if (width >= 1025 && width < 1241 && widowSizeSlideRender !== 920) {
			widowSizeSlideRender = 920;
			$slider.sliderPro(_.extend({}, baseSliderOptions, {
				height: 386,
				thumbnailWidth: 236,
				thumbnailHeight: 128,
				thumbnailsPosition: "right"
			}));
		} else if (width < 1025 && widowSizeSlideRender !== 760) {
			widowSizeSlideRender = 760;
			$slider.sliderPro(_.extend({}, baseSliderOptions, {
				height: 386,
				thumbnailWidth: 236,
				thumbnailHeight: 128,
				thumbnailsPosition: "right"
			}));
		}
	}).trigger("resize");
};

let HotelPageGalleryView = {
	init: initGallery
};

export default HotelPageGalleryView;
